<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0 login-auth-inner">
      <div class="main_block">
        <div class="header_block_div">
          <div class="reg_logo_section">
            <a class="brand-logo" @click="toAequitex">
              <img src="../../assets/images/logo/logo-green.png" alt="Logo">
            </a>
          </div>
          <div class="reg-lang-section">
            <div class="register-languages-mobile small_screen_lang d-flex align-items-end justify-content-end">
              <b-dropdown
                id="dropdown-grouped"
                text="Dark"
                variant="outline-dark"
                class="dropdown-language no-border-button"
                right
              >
                <template #button-content>
                  <b-img
                    :src="currentLocale.img"
                    height="14px"
                    width="22px"
                    :alt="currentLocale.locale"
                  />
                  <span class="ml-50 text-body">{{ $t(currentLocale.name) }}</span>
                </template>
                <b-dropdown-item
                  v-for="localeObj in locales"
                  :key="localeObj.locale"
                  @click="setLocale(localeObj.locale)"
                >
                  <b-img
                    :src="localeObj.img"
                    height="14px"
                    width="22px"
                    :alt="localeObj.locale"
                  />
                  <span class="ml-50">{{ $t(localeObj.name) }}</span>
                </b-dropdown-item>
              </b-dropdown>
            </div>
          </div>
        </div>

        <div class="reg-content-section">
          <b-col class="d-lg-flex align-items-center p-5 register_section_buttons register-hero-col">
            <b-row class="col-md-12 flex-column align-items-start">
              <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
                <b-img fluid class="login-hero-img" :src="loginImg" alt="Login V2" />
              </div>
            </b-row>
          </b-col>

          <b-col class="row auth-bg px-1 p-2 pt-5 login-form-col">
            <div class="form_block">
              <div class="form_block_header">
                <b-card-title
                  title-tag="h2"
                  class="font-weight-bold col-md-12 pl-0 pb-0 mb-0"
                >
                  {{ $t('login_text') }}
                </b-card-title>
              </div>

              <b-col sm="12" md="12" lg="12" class="px-xl-2 mx-auto mt-2 login-form-body">
                <b-card-title
                  title-tag="h2"
                  class="font-weight-bold mb-2 col-md-12 pl-0"
                >
                  {{ $t('welcome_to_hive') }}
                </b-card-title>

                <b-card-text class="mb-2">
                  {{ $t('login_subtitle') }}
                </b-card-text>

                <validation-observer ref="loginValidation">
                  <b-form class="auth-login-form mt-2" @submit.prevent="validationForm">
                    <b-form-group :label="$t('email')" label-for="login-email">
                      <validation-provider
                        #default="{ errors }"
                        name="Email"
                        rules="required|email"
                      >
                        <b-form-input
                          id="login-email"
                          v-model.trim="userEmail"
                          :state="errors.length > 0 ? false : null"
                          name="login-email"
                          tabindex="1"
                          placeholder="john@example.com"
                          :disabled="disableInputs"
                        />
                        <small class="text-danger">{{ $t(errors[0]) }}</small>
                      </validation-provider>
                    </b-form-group>

                    <b-form-group>
                      <div class="d-flex justify-content-between">
                        <label for="login-password">{{ $t('password') }}</label>
                      </div>
                      <validation-provider
                        #default="{ errors }"
                        name="Password"
                        rules="required"
                      >
                        <b-input-group
                          class="input-group-merge"
                          :class="errors.length > 0 ? 'is-invalid' : null"
                        >
                          <b-form-input
                            id="login-password"
                            v-model.trim="password"
                            tabindex="2"
                            :state="errors.length > 0 ? false : null"
                            class="form-control-merge"
                            :type="passwordFieldType"
                            name="login-password"
                            placeholder="············"
                            :disabled="disableInputs"
                          />
                          <b-input-group-append is-text>
                            <feather-icon
                              class="cursor-pointer"
                              :icon="passwordToggleIcon"
                              @click="togglePasswordVisibility"
                            />
                          </b-input-group-append>
                        </b-input-group>
                        <small class="text-danger">{{ $t(errors[0]) }}</small>
                      </validation-provider>
                    </b-form-group>

                    <div class="d-flex justify-content-between">
                      <b-form-group>
                        <b-form-checkbox
                          id="remember-me"
                          v-model="rememberMe"
                          tabindex="3"
                          name="checkbox-1"
                        >
                          {{ $t('remember_me') }}
                        </b-form-checkbox>
                      </b-form-group>
                      <b-link :to="{ name: 'forgot-password' }">
                        <small>{{ $t('forgot_password') }}</small>
                      </b-link>
                    </div>

                    <b-button
                      type="submit"
                      variant="primary"
                      block
                      tabindex="4"
                      :disabled="disableInputs"
                    >
                      {{ $t('sign_in') }}
                    </b-button>
                  </b-form>
                </validation-observer>

                <b-card-text class="text-center mt-2">
                  <span>{{ $t('new_on_our_platform') }}</span>
                  <b-link tabindex="5" :to="{ name: 'register' }">
                    <span>&nbsp;{{ $t('create_an_account') }}</span>
                  </b-link>
                </b-card-text>
              </b-col>
            </div>
          </b-col>

          <b-col class="pt-5 login-booking-col">
            <iframe
              width="100%"
              height="100%"
              :src="bookingIframeSrc"
              title="Book appointment"
              frameborder="0"
              allowfullscreen
            />
          </b-col>
        </div>
      </div>
    </b-row>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BDropdown,
  BDropdownItem,
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

const LOCALES = [
  { locale: 'en', img: '/images/flags/en.png', name: 'english' },
  { locale: 'de', img: '/images/flags/german.png', name: 'german' },
]

const BOOKING_IFRAME_SRC = 'https://support-aequitex.zohobookings.eu/portal-embed#/customer/167264000000318034'

const LOGIN_IMG = require('@/assets/images/pages/login-v5.png')

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BDropdown,
    BDropdownItem,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      rememberMe: false,
      password: '',
      userEmail: '',
      disableInputs: false,
      required,
      email,
      locales: LOCALES,
      loginImg: LOGIN_IMG,
      bookingIframeSrc: BOOKING_IFRAME_SRC,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    currentLocale() {
      return this.locales.find(locale => locale.locale === this.$i18n.locale)
        || this.locales[0]
    },
  },
  created() {
    this.$store.commit('app/UPDATE_LANGUAGE', this.$i18n.locale || this.locales[0].locale)
  },
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale
      this.$store.commit('app/UPDATE_LANGUAGE', locale)
    },
    toAequitex() {
      window.location.href = 'https://www.aequitex.com/'
    },
    showToast(title, variant, icon) {
      this.$toast({
        component: ToastificationContent,
        props: { title, icon, variant },
      })
    },
    failedToAuthActions(message) {
      this.$store.commit('auth/UPDATE_TOKEN', null)
      this.disableInputs = false
      this.showToast(message, 'error', 'ErrorIcon')
    },
    getPostLoginRedirect(user) {
      const params = new URLSearchParams(window.location.search)

      if (user.status !== 1) {
        return null
      }
      if (params.has('source')) {
        return params.has('id')
          ? `/${params.get('source')}/${params.get('id')}`
          : `/${params.get('source')}`
      }
      if (params.has('form')) {
        return '/cookpit/task/fill-online-form'
      }
      return '/'
    },
    handleTwoFactorRedirect(userId) {
      sessionStorage.setItem('two_factor_user_id', userId)
      const suffix = new URLSearchParams(window.location.search).has('form') ? '?form' : ''
      window.location.href = `/two-factor-verify${suffix}`
    },
    async validationForm() {
      try {
        const success = await this.$refs.loginValidation.validate()
        if (!success) return

        this.disableInputs = true

        const { data } = await this.$http.post('/login', {
          email: this.userEmail,
          password: this.password,
          remember: this.rememberMe,
          language: this.currentLocale.locale,
        })

        if (data.status === 200) {
          const value = data.value

          if (value.two_factor) {
            this.handleTwoFactorRedirect(value.user_id)
            return
          }

          this.$store.commit('auth/SET_AUTHENTICATED', true)
          this.$store.commit('auth/SET_USER', value)
          this.$store.commit('auth/UPDATE_TOKEN', value.token)
          this.$store.commit('auth/SHOW_ALERT', true)

          this.showToast(this.$t('successfully_logged_in'), 'success', 'SuccessIcon')

          const redirectUrl = this.getPostLoginRedirect(value)
          if (redirectUrl) {
            window.location.href = redirectUrl
          } else {
            this.$router.push('/verify')
          }
          return
        }

        if (data.status === 403 && data.message === this.$t('activate_account_by_verifying')) {
          this.$store.commit('auth/SET_AUTHENTICATED', true)
          this.$store.commit('auth/SET_USER', { email: this.userEmail })
          this.$store.commit('auth/UPDATE_TOKEN', null)
          this.$router.push('/verify')
          return
        }

        if (data.status === 403) {
          this.failedToAuthActions(this.$t('user-deactivated'))
          return
        }

        this.failedToAuthActions(this.$t('failed_to_authenticate_with_provided_credentials.'))
      } catch (error) {
        this.$store.commit('auth/SET_USER', [])
        this.$store.commit('auth/SET_AUTHENTICATED', false)
        this.$store.commit('auth/UPDATE_TOKEN', null)
        this.disableInputs = false
        this.showToast(
          this.$t('failed_to_authenticate_with_provided_credentials.'),
          'error',
          'ErrorIcon',
        )
      }
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/pages/page-auth.scss";

.header_block_div > a,
.header_block_div > div {
  width: 10%;
}

.form_block {
  background-color: white;
  width: 100%;
  border-radius: 25px;
  overflow: hidden;
  height: fit-content;
}

.form_block .form_block_header {
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #555;
  padding: 20px;
}

.form_block .form_block_header h2,
.form_block .form_block_header span {
  color: #222f28;
}

.form_block input,
.form_block select {
  background-color: #F7F6F4;
}

.form_block button {
  background-color: #577264 !important;
}

@media screen and (max-width: 992px) {
  .register_section_buttons {
    margin-top: 25px;
    padding: 0 40px !important;
  }

  .small_screen_lang {
    display: block;
    margin: 25px 0;
    text-align: right !important;
  }
}
</style>

<style scoped>
.login-auth-inner {
  margin: 0 auto !important;
}

.main_block {
  width: 2100px;
  max-width: 2100px;
  margin: 0 auto;
}

.reg-content-section {
  width: 100%;
  height: calc(100% - 70px);
  display: flex;
}

.reg-content-section > div {
  width: 33%;
  height: 100%;
  display: flex;
}

.header_block_div {
  width: 100%;
  height: 70px;
  display: flex;
  align-items: center;
  background-color: #F7F6F4;
}

.brand-logo {
  position: unset !important;
}

.reg_logo_section {
  width: 15%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.reg-lang-section {
  width: 85%;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
iframe{
  height: 750px;
}
.register-hero-col,
.login-form-col,
.login-booking-col {
  background-color: #F7F6F4;
}

.register-hero-col {
  padding: 0 !important;
}

.login-form-col {
  margin: 0 auto;
}

.login-form-body {
  height: 545px;
  padding-top: 65px;
}

.login-hero-img {
  width: 100%;
}

.login-booking-col {
  background: rgb(247, 246, 244);
}
@media screen and (min-width: 2000px) {
  .reg-content-section > div{
    align-items: center;
  }
  iframe {
    margin-top: 70px;
  }
}

@media screen and (max-width: 1250px) {
  .header_block_div > div {
    width: 50%;
  }

  .reg-content-section {
    flex-direction: column;
  }

  .reg-content-section > div {
    width: 100%;
    justify-content: center;
  }

  .register_section_buttons {
    margin: 0 !important;
  }

  .form_block {
    width: 50%;
  }

  iframe {
    width: 50%;
  }
}

@media screen and (max-width: 800px) {
  .form_block {
    width: 100%;
    margin: 0 !important;
    padding: 0 !important;
  }

  iframe {
    margin-top: 40px;
    width: 100%;
  }
}
</style>
